import timeZones from './time-zones.json' with { type: 'json' };

export const fetchTimeZones = (_options: { signal?: AbortController['signal'] } = {}) => Promise.resolve(timeZones);
